import { ShoppingBagIcon } from './Icons';

interface EmptyStateProps {
  title: string;
  description?: string;
  action?: React.ReactNode;
}

export function EmptyState({ title, description, action }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-center gap-3">
      <ShoppingBagIcon className="w-8 h-8 text-text-light" />
      <h3 className="text-lg font-semibold text-text-medium">{title}</h3>
      {description && <p className="text-text-light text-sm max-w-xs">{description}</p>}
      {action && <div className="mt-2">{action}</div>}
    </div>
  );
}
